module.exports = "/blue-checkaa89cafd6ed8567da03f152319f3479c.svg";